import React, { useState, useEffect } from 'react';
import api from '../../services/api';

export default function CashDrawer() {
  const user = JSON.parse(localStorage.getItem('sdx_user') || '{}');
  const [hubs, setHubs] = useState([]);
  const [hubId, setHubId] = useState(user.hub_id || 1);
  const [data, setData] = useState(null);
  const [outAmount, setOutAmount] = useState('');
  const [outSource, setOutSource] = useState('bank_deposit');
  const [outNotes, setOutNotes] = useState('');
  const [inAmount, setInAmount] = useState('');
  const [inSource, setInSource] = useState('float_deposit');
  const [inNotes, setInNotes] = useState('');
  const [msg, setMsg] = useState('');

  const load = async () => {
    try {
      const res = await api.get(`/cash/hub/${hubId}/summary`);
      setData(res.data);
    } catch (_) { setData(null); }
  };
  useEffect(() => { api.get('/hubs').then(r => setHubs(r.data)); }, []);
  useEffect(() => { load(); }, [hubId]);

  const settle = async (rider_user_id) => {
    if (!window.confirm('Settle this rider\'s cash now?')) return;
    setMsg('');
    try {
      const res = await api.post('/cash/settle', { rider_user_id, hub_id: hubId });
      setMsg(`Settled K${res.data.total} — rider unblocked.`);
      load();
    } catch (e) { setMsg(e.response?.data?.error || 'Error'); }
  };

  const doIn = async () => {
    if (!inAmount || Number(inAmount) <= 0) return;
    if (!window.confirm(`Record K${inAmount} in (${inSource})?`)) return;
    setMsg('');
    try {
      await api.post(`/cash/hub/${hubId}/in`, { amount: Number(inAmount), source: inSource, notes: inNotes });
      setMsg(`Recorded K${inAmount} in.`);
      setInAmount(''); setInNotes('');
      load();
    } catch (e) { setMsg(e.response?.data?.error || 'Error'); }
  };

  const doOut = async () => {
    if (!outAmount || Number(outAmount) <= 0) return;
    if (!window.confirm(`Record K${outAmount} out (${outSource})?`)) return;
    setMsg('');
    try {
      await api.post(`/cash/hub/${hubId}/out`, { amount: Number(outAmount), source: outSource, notes: outNotes });
      setMsg(`Recorded K${outAmount} out.`);
      setOutAmount(''); setOutNotes('');
      load();
    } catch (e) { setMsg(e.response?.data?.error || 'Error'); }
  };

  const inTotal  = (data?.today || []).filter(t => t.direction === 'in').reduce((s, t) => s + t.total, 0);
  const outTotal = (data?.today || []).filter(t => t.direction === 'out').reduce((s, t) => s + t.total, 0);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h1 style={{ margin: 0 }}>Cash Drawer</h1>
        <select className="input" style={{ width: 240, marginBottom: 0 }} value={hubId} onChange={e => setHubId(Number(e.target.value))}>
          {hubs.map(h => <option key={h.id} value={h.id}>{h.name} ({h.city})</option>)}
        </select>
      </div>

      {data && (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 20 }}>
            <div className="card" style={{ margin: 0 }}>
              <div className="label">Drawer Balance</div>
              <div style={{ fontSize: 28, fontWeight: 800, color: '#16a34a' }}>K{Number(data.hub.cash_drawer_balance || 0).toFixed(2)}</div>
            </div>
            <div className="card" style={{ margin: 0 }}>
              <div className="label">Cash In Today</div>
              <div style={{ fontSize: 28, fontWeight: 800, color: '#16a34a' }}>+K{inTotal.toFixed(2)}</div>
            </div>
            <div className="card" style={{ margin: 0 }}>
              <div className="label">Cash Out Today</div>
              <div style={{ fontSize: 28, fontWeight: 800, color: '#dc2626' }}>−K{outTotal.toFixed(2)}</div>
            </div>
          </div>

          <div className="card">
            <h2 style={{ marginTop: 0 }}>Riders with Outstanding Cash</h2>
            {(data.unsettled || []).length === 0 ? (
              <p style={{ color: '#6b7280' }}>All riders settled ✓</p>
            ) : (
              <table style={{ width: '100%', fontSize: 13 }}>
                <thead>
                  <tr style={{ textAlign: 'left', color: '#6b7280', fontSize: 11, textTransform: 'uppercase' }}>
                    <th style={{ padding: '6px 0' }}>Rider</th><th># Collections</th><th style={{ textAlign: 'right' }}>Total</th><th></th>
                  </tr>
                </thead>
                <tbody>
                  {data.unsettled.map(r => (
                    <tr key={r.rider_user_id} style={{ borderTop: '1px solid #f3f4f6' }}>
                      <td style={{ padding: '8px 0' }}>{r.rider_name}</td>
                      <td>{r.n}</td>
                      <td style={{ textAlign: 'right', fontWeight: 700, color: r.total >= 200 ? '#dc2626' : '#16a34a' }}>K{r.total.toFixed(2)}</td>
                      <td style={{ textAlign: 'right' }}>
                        <button className="btn btn-primary" onClick={() => settle(r.rider_user_id)}>Settle</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          <div className="card">
            <h2 style={{ marginTop: 0 }}>Record Cash In (Float / Correction)</h2>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 2fr', gap: 12 }}>
              <input className="input" type="number" placeholder="Amount (K)" value={inAmount} onChange={e => setInAmount(e.target.value)} />
              <select className="input" value={inSource} onChange={e => setInSource(e.target.value)}>
                <option value="float_deposit">Float Deposit</option>
                <option value="cash_correction">Cash Correction</option>
                <option value="other_in">Other</option>
              </select>
              <input className="input" placeholder="Notes" value={inNotes} onChange={e => setInNotes(e.target.value)} />
            </div>
            <button className="btn btn-primary" onClick={doIn}>Record In</button>
          </div>

          <div className="card">
            <h2 style={{ marginTop: 0 }}>Record Cash Out</h2>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 2fr', gap: 12 }}>
              <input className="input" type="number" placeholder="Amount (K)" value={outAmount} onChange={e => setOutAmount(e.target.value)} />
              <select className="input" value={outSource} onChange={e => setOutSource(e.target.value)}>
                <option value="bank_deposit">Bank Deposit</option>
                <option value="office_expense">Office Expense</option>
                <option value="dispatch_fee">Dispatch Fee</option>
                <option value="refund">Refund</option>
                <option value="other">Other</option>
              </select>
              <input className="input" placeholder="Notes" value={outNotes} onChange={e => setOutNotes(e.target.value)} />
            </div>
            <button className="btn btn-primary" onClick={doOut}>Record Out</button>
          </div>

          {msg && <p style={{ color: msg.includes('Error') ? '#dc2626' : '#16a34a' }}>{msg}</p>}
        </>
      )}
    </div>
  );
}
